import { Alert, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { DialogProps } from "../misc/DialogProps";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { Course, coursesProvider } from "../providers/coursesProvider";
import { SaveButton2 } from "../buttons/SaveButton2";
import { Form2 } from "../misc/Form2";
import { DateInput, required } from "react-admin";
import { date, dateMaxYear } from "../utils/validators";
import { formatDate } from "../utils/calendar";
import { DateWithoutTime } from "../model/DateWithoutTime";

export function CloneCourseDialog(props: { course: Course; onCloned: (clone: Course) => void } & DialogProps) {
  const { course, onCloned, ...dialogProps } = props;

  const onSubmit = ({ cloneStartDate }: { cloneStartDate: string }) =>
    coursesProvider.cloneSafely(
      { source: course, cloneStartDate: DateWithoutTime.fromString(cloneStartDate) },
      {
        errorMessage: `Fehler beim Klonen des ${course.name} Kurses.`,
        successMessage: `${course.name} Kurs erfolgreich geklont.`,
        onSuccess: (clone: Course) => {
          dialogProps.onClose();
          onCloned(clone);
        },
      },
    );

  return (
    <Dialog {...dialogProps} maxWidth="sm" fullWidth>
      <DialogTitle>Kurs klonen</DialogTitle>
      <DialogCloseButton onClick={dialogProps.onClose} />
      <Form2 onSubmit={onSubmit} defaultValues={{ cloneStartDate: null }}>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 2 }}>
            {`Mit Klick auf den (Kurs klonen) Button wird ein neuer ${course.name} Kurs mit dem unten ausgewählten Kursbeginn erstellt. Dabei werden alle Termine des Kurses vom ${formatDate(course.start)} bis ${formatDate(course.end)} zeitversetzt entsprechend des gewählten Kursbeginns in den neu erstellten Kurs herüber kopiert (außer sie würden auf einen Feiertag fallen).`}
          </Alert>
          <DateInput
            label="Kursbeginn des Klons"
            source="cloneStartDate"
            validate={[required("Bitte wähle ein Datum aus."), date(), dateMaxYear(2099)]}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <SaveButton2 label="Kurs klonen" />
        </DialogActions>
      </Form2>
    </Dialog>
  );
}
